import React from 'react';
import { Formik, Form } from 'formik';
import Yup from 'yup';
import { withApollo } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';

import styles from './statusUpdateFormStyles';

import StatusUpdateFields from './StatusUpdateFields/statusUpdateFields';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

const SecuritiesQuery = gql`
  query Securities($symbol: String) {
    securities(symbol: $symbol) {
      edges {
        node {
          id
          display
        }
      }
    }
  }
`;

const openGraphDataQuery = gql`
  query OpenGraphData($ogUrl: String) {
    openGraphData(ogUrl: $ogUrl) {
      ogUrl
      ogTitle
      ogPreviewImageUrl
      ogDescription
      domain
    }
  }
`;

const validationSchema = Yup.object().shape({
  body: Yup.string()
    .required('Body cannot be blank')
    .test('adjustedCharLen', 'Please limit to 300 characters', value => {
      if (!value) return true;
      const foundEntities = value.match(/\$\[[^\]]*\]\([^)]*\)/g);
      const adjustedCharLimit = 301 + (foundEntities ? foundEntities.join('').length : 0);
      return value.length < adjustedCharLimit;
    }),
  term1: Yup.boolean().oneOf([true], 'Please accept all disclaimers before posting'),
  term2: Yup.boolean().oneOf([true], 'Please accept all disclaimers before posting'),
  term3: Yup.boolean().oneOf([true], 'Please accept all disclaimers before posting')
});

class StatusUpdateForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openGraphData: null,
      renderPlaceholder: true
    };

    this.handleOpenGraphQuery = this.handleOpenGraphQuery.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.search = this.search.bind(this);
  }

  search(search, callback) {
    this.props.client
      .query({
        query: SecuritiesQuery,
        variables: { symbol: search }
      })
      .then(({ data: { securities } }) => {
        callback(
          securities.edges.map(edge => {
            return edge.node;
          })
        );
      });
  }

  handleOpenGraphQuery(value, setFieldValue) {
    const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

    const urls = value.match(regex);

    if (urls) {
      //By default, if more than one URL is present, we just take the first one
      this.props.client
        .query({
          query: openGraphDataQuery,
          variables: { ogUrl: urls[0] }
        })
        .then(({ data: { openGraphData } }) => {
          setFieldValue('ogUrl', openGraphData.ogUrl);
          this.setState({ openGraphData });
        });
    }
  }

  handleSubmit(values, { resetForm }) {
    this.props.onSubmit(values).then(() => {
      this.setState({ openGraphData: null });
      resetForm({
        body: this.props.tickerTagString,
        tagList: '',
        term1: true,
        term2: true,
        term3: true,
        asAdmin: false,
        files: []
      });
    });
  }

  renderPlaceholder() {
    const { profileImageUrl } = this.props;
    return (
      <div className={`${styles.wrap} ${styles.formExpand}`}>
        <ProfileImage source={profileImageUrl} size={'small'} />
        <div
          id="post-form-placeholder"
          onClick={() => this.setState({ renderPlaceholder: false })}
          className={styles.formDummy}
        >
          Share your insights...
        </div>
      </div>
    );
  }

  render() {
    const termsAccepted = this.props.isAdmin || this.props.termsAccepted;

    if (this.state.renderPlaceholder) return this.renderPlaceholder();

    return (
      <Formik
        initialValues={{
          body: this.props.tickerTagString,
          tagList: '',
          term1: termsAccepted,
          term2: termsAccepted,
          term3: termsAccepted,
          asAdmin: false,
          files: []
        }}
        onSubmit={this.handleSubmit}
        validationSchema={validationSchema}
        render={formikProps => {
          return (
            <Form>
              <StatusUpdateFields
                isAdmin={this.props.isAdmin}
                profileImageUrl={this.props.profileImageUrl}
                handleOpenGraphQuery={this.handleOpenGraphQuery}
                openGraphData={this.state.openGraphData}
                search={this.search}
                termsAccepted={termsAccepted}
                uploadedFiles={formikProps.values.files}
                ref={n => (this.postFields = n)}
                closeForm={() => this.setState({ renderPlaceholder: true })}
                {...formikProps}
              />
            </Form>
          );
        }}
      />
    );
  }
}

export const StatusUpdateFormComp = StatusUpdateForm;

export default withApollo(StatusUpdateForm);
